/**
 * Live-session / live-practice cards stay in «upcoming / Скоро» feeds
 * across the app (Practices home, Calendar page feed, Dashboard panel)
 * for a short grace window past their scheduled start so a viewer who
 * tapped in late can still find the joined session.
 *
 * Past the grace window, the only surface that keeps the room visible
 * is the dedicated Live Practices page until the session ends — then
 * the card moves into archive.
 *
 * Owner directive 2026-05-08: «спустя две минуты после старта».
 */
export const UPCOMING_FEED_GRACE_MS = 2 * 60 * 1000;

/**
 * True iff a card with the given scheduled start is still fresh enough
 * to render in an upcoming/«Скоро начнутся» feed. Cards with no start
 * time pass through (they're un-schedulable; let the feed decide).
 */
export function isVisibleInUpcomingFeed(
  startDateTimeUtc: string | null | undefined,
  now: number = Date.now(),
): boolean {
  if (!startDateTimeUtc) return true;
  const t = new Date(startDateTimeUtc).getTime();
  if (!Number.isFinite(t)) return true;
  return now < t + UPCOMING_FEED_GRACE_MS;
}
